module.exports = __webpack_public_path__ + "static/media/psd.a4289765.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/psd.svg
// module id = 605
// module chunks = 0